// src/components/GlobalLoadingBar.js
import React from 'react';
import { useLoading } from '../contexts/LoadingContext';
import { GoldfishLoader } from './GoldfishLoader';

const GlobalLoadingBar = () => {
    const { isLoading } = useLoading();
    if (!isLoading) return null;
    return (
        <>
            {/* Thin animated bar at the top */}
            <div style={{
                position:        'fixed',
                top:             0,
                left:            0,
                right:           0,
                height:          '3px',
                zIndex:          10000,
                background:      'linear-gradient(90deg, #f97316, #fb923c, #f97316)',
                backgroundSize:  '200% 100%',
                animation:       'gf-loading-slide 1.2s infinite linear',
            }} />

            {/* Full-page overlay — blocks all clicks, shows goldfish loader */}
            <div style={{
                position:             'fixed',
                inset:                0,
                zIndex:               9999,
                backdropFilter:       'blur(2px)',
                WebkitBackdropFilter: 'blur(2px)',
                background:           'rgba(0, 0, 0, 0.18)',
                cursor:               'wait',
                display:              'flex',
                alignItems:           'center',
                justifyContent:       'center',
            }}>
                <GoldfishLoader />
            </div>
        </>
    );
};

export default GlobalLoadingBar;